import { render } from "./AppOffcanvas.vue?vue&type=template&id=7b24ab5e"
import script from "./AppOffcanvas.vue?vue&type=script&lang=js"
export * from "./AppOffcanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__